import { Fragment, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { setAlert } from '../../../actions/alert';

import {
    listarMetodosPago,
    detallesMetodoPago,
    crearMetodoPago,
    editarMetodoPago,
    eliminarMetodoPago
} from '../../../actions/configuracion';

import NuevoMetodoPago from './NuevoMetodoPago';
import EditarMetodoPago from './EditarMetodoPago';
import EliminarMetodoPago from './EliminarMetodoPago';

const MetodosPago = () => {
    const dispatch = useDispatch();

    const { metodos_pago, metodo_pago_detalle } = useSelector(state => state.configuracion);

    const [busqueda, setBusqueda] = useState('');

    const [modalNuevo, setModalNuevo] = useState(false);
    const [modalEditar, setModalEditar] = useState(false);
    const [modalEliminar, setModalEliminar] = useState(false);

    const [metodoSeleccionado, setMetodoSeleccionado] = useState(null);

    useEffect(() => {
        const rutasBread = [
            { activo: false, nombre: 'Configuración', path: '/configuracion' },
            { activo: true, nombre: 'Métodos de pago', path: '/configuracion/metodos-pago' }
        ];
        dispatch(editarBreadcrumb(rutasBread));
        dispatch(listarMetodosPago());
    }, [dispatch]);

    const dataFiltrada = useMemo(() => {
        const q = busqueda.trim().toLowerCase();
        if (!q) return metodos_pago || [];
        return (metodos_pago || []).filter(m => {
            const nombre = (m?.nombre || '').toLowerCase();
            const descripcion = (m?.descripcion || '').toLowerCase();
            return nombre.includes(q) || descripcion.includes(q);
        });
    }, [busqueda, metodos_pago]);

    const onAbrirNuevo = () => {
        setModalNuevo(true);
    };

    const onEditar = async (row) => {
        const id = row?._id;
        if (!id) {
            dispatch(setAlert('Método inválido', 'danger'));
            return;
        }
        const ok = await dispatch(detallesMetodoPago(id));
        if (ok) {
            setMetodoSeleccionado(row);
            setModalEditar(true);
        }
    };

    const onEliminar = (row) => {
        const id = row?._id;
        if (!id) {
            dispatch(setAlert('Método inválido', 'danger'));
            return;
        }
        setMetodoSeleccionado(row);
        setModalEliminar(true);
    };

    const columns = useMemo(() => ([
        {
            name: 'Nombre',
            selector: row => row?.nombre || '',
            sortable: true,
            grow: 1
        },
        {
            name: 'Descripción',
            selector: row => row?.descripcion || '',
            sortable: false,
            grow: 2
        },
        {
            name: 'Opciones',
            cell: (row) => (
                <div className="d-flex align-items-center gap-3">
                    <button
                        type="button"
                        className="btn btn-link p-0 text-warning"
                        onClick={() => onEditar(row)}
                        title="Editar"
                    >
                        <i className="fas fa-edit" />
                    </button>
                    <button
                        type="button"
                        className="btn btn-link p-0 text-danger"
                        onClick={() => onEliminar(row)}
                        title="Eliminar"
                    >
                        <i className="fas fa-trash" />
                    </button>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            right: true
        }
    ]), []);

    return (
        <Fragment>
            <div className="container-fluid">
                <div class="row">
                    <div className="col-10 offset-1">
                        <div className="row mb-4">
                            <div className="col-12">
                                <h2 className="my-5">Métodos de pago</h2>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-12 d-flex justify-content-end align-items-center gap-2">
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ maxWidth: 280 }}
                                    placeholder="Buscar en la tabla..."
                                    value={busqueda}
                                    onChange={(e) => setBusqueda(e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={onAbrirNuevo}
                                >
                                    Agregar método
                                </button>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <DataTable
                                    columns={columns}
                                    data={dataFiltrada}
                                    pagination
                                    highlightOnHover
                                    striped
                                    noDataComponent="No hay métodos de pago registrados"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {modalNuevo && (
                <NuevoMetodoPago
                    show={modalNuevo}
                    onClose={() => setModalNuevo(false)}
                    onSave={async (payload) => {
                        const ok = await dispatch(crearMetodoPago(payload));
                        if (ok) setModalNuevo(false);
                    }}
                />
            )}

            {modalEditar && (
                <EditarMetodoPago
                    show={modalEditar}
                    onClose={() => setModalEditar(false)}
                    metodo={metodo_pago_detalle}
                    onSave={async (payload) => {
                        const ok = await dispatch(editarMetodoPago(payload));
                        if (ok) setModalEditar(false);
                    }}
                />
            )}

            {modalEliminar && (
                <EliminarMetodoPago
                    show={modalEliminar}
                    onClose={() => setModalEliminar(false)}
                    metodo={metodoSeleccionado}
                    onDelete={async () => {
                        const id = metodoSeleccionado?._id;
                        const ok = await dispatch(eliminarMetodoPago(id));
                        if (ok) setModalEliminar(false);
                    }}
                />
            )}
        </Fragment>
    );
};

export default MetodosPago;
